module.exports = __webpack_public_path__ + "static/img/Main.a2c29ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main.jpg
// module id = oEl6
// module chunks = 0